import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";
import { classNames } from "../../helpers/classNames";

export default function PopoverDropdown({
  children,
  content,
  buttonLabel = "popover button",
  buttonClass,
  contentClass,
}) {
  return (
    <Popover>
      {({ open }) => (
        <>
          <PopoverButton
            className={classNames(
              "bg-primary h-10 px-3 py-2 rounded-md text-white",
              buttonClass
            )}
          >
            {buttonLabel}
          </PopoverButton>
          {open && (
            <PopoverPanel
              transition
              anchor="bottom"
              className="relative z-0 before:content-[''] before:absolute before:!bg-black/20 before:w-4 before:h-4 before:top-0 before:left-1/2 before:right-1/2 before:-translate-x-1/2 before:shadow-lg before:rotate-45 before:-z-[1] !overflow-visible mt-1"
            >
              <div
                className={classNames(
                  "bg-white shadow-md rounded-md min-w-60 max-w-auto relative border border-primary bg-primary/10 p-3 mt-[5px]",
                  contentClass
                )}
              >
                {children || content}
              </div>
            </PopoverPanel>
          )}
        </>
      )}
    </Popover>
  );
}

// divide-y divide-white/5 rounded-xl bg-white/5 text-sm/6 transition duration-200 ease-in-out [--anchor-gap:--spacing(5)] data-closed:-translate-y-1 data-closed:opacity-0
